import { SVGProps } from "react";

export type SupportProps = SVGProps<SVGSVGElement>;

const GamdomIcon: React.FC<SupportProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 28" fill="none">
      <path d="M11.1406 17.415H11.137V24.3343H11.1406V17.415Z" fill="#E9F4FF" />
      <path d="M11.1406 17.415H11.137V24.3343H11.1406V17.415Z" fill="#E9F4FF" />
      <path
        d="M10.5746 13.8755L3.65167 17.1498C3.44611 17.2489 3.31396 17.4618 3.31396 17.693V24.0506C3.31396 24.2856 3.44611 24.4948 3.65167 24.5939L10.5782 27.8718C10.7544 27.9562 10.9453 27.9966 11.1362 27.9966V13.7471C10.9453 13.7507 10.7544 13.7948 10.5746 13.8755Z"
        fill="#00FF86"
      />
      <path
        d="M10.8285 0.0734124L7.57994 1.68117V6.00155L3.77712 7.86625V3.50916L0.370739 5.20135C0.143157 5.31514 0 5.54639 0 5.79599V14.1211C0 14.6093 0.517564 14.9323 0.954375 14.7157L10.5458 10.0099C10.7331 9.91816 10.9349 9.87411 11.1368 9.87411V0C11.0304 0 10.9239 0.0256936 10.8285 0.0734124Z"
        fill="#00FF86"
      />
      <path
        d="M18.6251 17.1503L11.6986 13.876C11.5187 13.7879 11.3278 13.7475 11.137 13.7512V28.0008C11.3278 28.0008 11.5261 27.9604 11.7022 27.876L18.6251 24.5981C18.8307 24.4989 18.9628 24.286 18.9628 24.0548V17.6972C18.9628 17.4623 18.8307 17.2494 18.6251 17.1503Z"
        fill="#E9F4FF"
      />
      <path
        d="M21.9067 5.20061L18.5003 3.50842V7.86919L14.6938 6.00448V1.6841L11.4453 0.0763421C11.3499 0.0286233 11.2397 0.00292969 11.137 0.00292969V9.87704C11.3388 9.87704 11.5407 9.92476 11.7279 10.0129L21.3194 14.7187C21.7599 14.9352 22.2738 14.6122 22.2738 14.124V5.79892C22.2775 5.54565 22.1343 5.3144 21.9067 5.20061Z"
        fill="#E9F4FF"
      />
    </svg>
  );
};

export default GamdomIcon;
